module.exports = __webpack_public_path__ + "static/img/clarin-pl_logo_pl_white.3aac98c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/clarin-pl_logo_pl_white.png
// module id = VGRX
// module chunks = 0